import moment from 'moment'
import i18n, {resolveLanguage} from '@/i18n'
import vuetify from '@/plugins/vuetify'

/**
 * O idioma em que o app se mostra, num lugar só.
 *
 * Ele mora em quatro: o vue-i18n (os textos), o Vuetify (os textos dele, como "Nenhum dado"), o
 * moment (o começo da semana, os nomes dos meses) e o `lang` da página — sem este, o navegador não
 * sabe em que idioma ela está, e oferecia traduzir para o português uma página já em português
 * (relato do usuário). Mudar o idioma é mudar os quatro, e cada um escrito num lugar divergiria.
 *
 * Quem chama: a partida (`main.ts`), o `sync` da conta — ela pode trazer um preferido escolhido em
 * outro aparelho —, a saída e o perfil.
 */

/**
 * Cada idioma no próprio nome: é como um seletor de idioma se lê em qualquer idioma — quem caiu numa
 * tela em espanhol sem saber espanhol acha "Português" ali. Por isso não estão nas traduções.
 */
export const LANGUAGE_NAMES: Record<string, string> = {
  'en': 'English',
  'pt-BR': 'Português (Brasil)',
  'es': 'Español',
  'ia': 'Interlingua'
}

/** O idioma que o navegador pede, resolvido para um que o app tem. */
export function browserLanguage(): string {
  return resolveLanguage(navigator.language)
}

/**
 * Aplica o idioma preferido da conta, ou — sem ele — o do navegador. Resolve para um que o app tem
 * e o põe nos quatro lugares.
 *
 * O Vuetify conhece as línguas sem a variante (`pt`, e não `pt-BR`), e a interlíngua ele não tem:
 * cai no inglês, que é o `fallback` dele.
 */
export function applyLanguage(preferred?: string | null) {
  const language = preferred ? resolveLanguage(preferred) : browserLanguage()
  ;(i18n.global as unknown as { locale: string }).locale = language
  vuetify.locale.current.value = language.split('-')[0]
  moment.locale(language)
  document.documentElement.lang = language
}
